
















































































import {Component, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"

@Component({
    components: {JdsButton, JdiPreview, JdsGlyph, JdsIcon, JdiContent}
})
export default class Icons extends Vue {

    select(i: string) {
        window.getSelection()!.selectAllChildren((this.$refs['icon-'+i] as Array<HTMLElement>)[0]);
    }

    get icons() {
        const context = require.context('!raw-loader!../../design-system/icons/glyphs', true, /.html$/);
         return context.keys().reduce((iconMapping: { [key: string]: {[key:string]: string} }, key) => {
            const filename = key.substring(key.lastIndexOf("/") + 1);
            const group = key.substring(2, key.lastIndexOf("/"));
            if (!iconMapping[group]) iconMapping[group] = {};
            iconMapping[group][filename.substring(0, filename.length - 5)] = context(key).default;
            return iconMapping;
        }, {});
    }
}
